import CardActionFavorite from "./card-action-favorite";

export default CardActionFavorite;
